export const UNTITLED_ARTIFACT_DISPLAY = 'Untitled';
/**
 * Resolve the user-facing title without turning a presentation fallback into
 * semantic title state. Attachment filenames live in metadata while an
 * asynchronous AI title is pending.
 */
export function resolveArtifactDisplayTitle(title, metadata) {
    const semanticTitle = title?.trim();
    if (semanticTitle)
        return semanticTitle;
    if (metadata && typeof metadata === 'object' && !Array.isArray(metadata)) {
        const fileName = metadata.fileName;
        if (typeof fileName === 'string' && fileName.trim())
            return fileName.trim();
    }
    return UNTITLED_ARTIFACT_DISPLAY;
}
//# sourceMappingURL=artifactDisplayTitle.js.map